/**
 * Fase 2 (W32): a tela do app restaurada do cache de ida e volta do navegador (bfcache) fica escondida até o servidor
 * confirmar a sessão; sem ela (saiu por outra página, 401), vai ao login por carga nova, sem o que estava na memória.
 *
 * Review r23 segurança (O2): com a rede falhando na conferência, a tela antiga reaparecia (`catch` mostrava a raiz): num
 * aparelho compartilhado e offline, o Voltar devolvia os dados de quem saiu. Agora ela segue escondida enquanto a conferência
 * não responde: tenta de novo com espera crescente e, esgotadas as tentativas, vai ao login (nunca mostra sem confirmar).
 */
export interface DepsVoltaBfcache {
  raiz: Pick<HTMLElement, 'setAttribute' | 'removeAttribute'> | null;
  /** Confere a sessão no servidor (`GET /api/v1/auth/sessao`); rejeita em falha de rede. */
  conferir: () => Promise<{ ok: boolean }>;
  irAoLogin: () => void;
  esperar?: (ms: number) => Promise<void>;
  tentativas?: number;
}

const ESPERAS_MS = [1000, 2000, 4000, 8000, 15000];

export async function conferirVoltaDoBfcache(d: DepsVoltaBfcache): Promise<'mostrou' | 'login'> {
  const esperar = d.esperar ?? ((ms: number) => new Promise<void>((r) => setTimeout(r, ms)));
  const tentativas = d.tentativas ?? ESPERAS_MS.length + 1;
  d.raiz?.setAttribute('hidden', '');
  for (let i = 0; i < tentativas; i++) {
    try {
      const r = await d.conferir();
      if (r.ok) {
        d.raiz?.removeAttribute('hidden');
        return 'mostrou';
      }
      d.irAoLogin();
      return 'login';
    } catch {
      if (i < tentativas - 1) await esperar(ESPERAS_MS[Math.min(i, ESPERAS_MS.length - 1)]!);
    }
  }
  d.irAoLogin();
  return 'login';
}
